export enum ReadOnlyReason {
  DeliveryApproved = 'DeliveryApproved',
  DeliveryCancelled = 'DeliveryCancelled',
}
